import { Loader } from '@/components/ui'
import { ScreeningBreakdown } from '@/modules/tools/bankruptcy/components/CasePage/ScreeningBreakdown'
import {
  useFetchProjectScreening,
  useLoadingProjectScreening,
  useProjectScreening,
} from '@/modules/tools/bankruptcy/hooks'
import { VersionList } from './VersionList'

export const ProjectScreeningPage = ({ slug }: { slug: string }) => {
  useFetchProjectScreening(slug)
  const screening = useProjectScreening()
  const loading = useLoadingProjectScreening()

  if (loading && !screening) {
    return (
      <div className="flex justify-center py-20">
        <Loader size="md" />
      </div>
    )
  }

  if (!screening) {
    return (
      <p className="py-20 text-center text-muted-foreground">
        This project has no screening.
      </p>
    )
  }

  return (
    <div className="max-w-3xl space-y-4">
      <ScreeningBreakdown filing={screening} />
      <VersionList versions={screening.versions} />
    </div>
  )
}
